export default __webpack_public_path__ + "static/media/media_icon.3e732dd8.svg";